module.exports = __webpack_public_path__ + "assets/NapoleonDetailed.ec764bbf977fbcb2f6e8866da738cdef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/NapoleonDetailed.png
// module id = 540
// module chunks = 0